/* __next_internal_client_entry_do_not_use__ DeferredPromoBanner auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { LazyPromoBanner } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/LazyPromoBanner";
import { useShowDeferredContent } from "@faire/web--source/common/deferredRender";
import React from "react";
export var DeferredPromoBanner = function() {
    var showDeferredContent = useShowDeferredContent();
    if (!showDeferredContent) {
        return null;
    }
    return /*#__PURE__*/ _jsx(LazyPromoBanner, {});
};
